import { FormSectionProps } from './types';
import { QuestionText } from './QuestionText';
import { FormSectionContainer } from './FormSectionContainer';

export function FormSection({ question, helperText, error, children }: FormSectionProps) {
  return (
    <FormSectionContainer>
      <QuestionText
        question={question}
        helperText={helperText}
        error={error}
      />
      {children}
    </FormSectionContainer>
  );
} 